import { render, staticRenderFns } from "./AnswerGroupResult.vue?vue&type=template&id=73e6345e&scoped=true"
import script from "./AnswerGroupResult.vue?vue&type=script&lang=ts"
export * from "./AnswerGroupResult.vue?vue&type=script&lang=ts"
import style0 from "./AnswerGroupResult.vue?vue&type=style&index=0&id=73e6345e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e6345e",
  null
  
)

export default component.exports